// Verticals API — public read of vertical hub pages.
import { useEffect, useState } from "react";

const BASE = "/api/verticals";

// Media URL rewriter reused from blogApi's implementation.
function _rewriteMediaUrl(u) {
  if (!u || typeof u !== "string") return u;
  const m = u.match(/^https?:\/\/[^/]+(\/api\/cms\/.+)$/i);
  if (m) return m[1];
  return u;
}
function _walkAndRewriteMedia(node) {
  if (node == null || typeof node !== "object") return node;
  if (Array.isArray(node)) {
    for (let i = 0; i < node.length; i += 1) node[i] = _walkAndRewriteMedia(node[i]);
    return node;
  }
  if (typeof node.url === "string" && (node.mimeType || node.filename || node.sizes)) {
    node.url = _rewriteMediaUrl(node.url);
    if (node.thumbnailURL) node.thumbnailURL = _rewriteMediaUrl(node.thumbnailURL);
    if (node.sizes && typeof node.sizes === "object") {
      for (const k of Object.keys(node.sizes)) {
        const s = node.sizes[k];
        if (s && typeof s === "object" && typeof s.url === "string") {
          s.url = _rewriteMediaUrl(s.url);
        }
      }
    }
  }
  for (const k of Object.keys(node)) {
    node[k] = _walkAndRewriteMedia(node[k]);
  }
  return node;
}

export async function fetchVerticalsList() {
  const r = await fetch(`${BASE}?depth=0`);
  if (!r.ok) throw new Error(`Verticals list failed: HTTP ${r.status}`);
  return _walkAndRewriteMedia(await r.json());
}

export async function fetchVerticalBySlug(slug) {
  const r = await fetch(`${BASE}/${encodeURIComponent(slug)}`);
  if (r.status === 404) return null;
  if (!r.ok) throw new Error(`Vertical fetch failed: HTTP ${r.status}`);
  return _walkAndRewriteMedia(await r.json());
}

export function useVerticalsList() {
  const [state, setState] = useState({ loading: true, error: null, data: null });
  useEffect(() => {
    let cancelled = false;
    fetchVerticalsList()
      .then((data) => !cancelled && setState({ loading: false, error: null, data }))
      .catch((e) => !cancelled && setState({ loading: false, error: e.message, data: null }));
    return () => { cancelled = true; };
  }, []);
  return state;
}

export function useVertical(slug) {
  const [state, setState] = useState({ loading: true, error: null, notFound: false, data: null });
  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    setState({ loading: true, error: null, notFound: false, data: null });

    // Fetch with one automatic retry on transient errors (network / 5xx /
    // timeout). Confirmed 404 does NOT retry. Guards prerenderers /
    // crawler-caches against snapshotting a transient not-found state.
    const attempt = (retriesLeft) =>
      fetchVerticalBySlug(slug)
        .then((data) => {
          if (cancelled) return;
          if (data === null) {
            setState({ loading: false, error: null, notFound: true, data: null });
          } else {
            setState({ loading: false, error: null, notFound: false, data });
          }
        })
        .catch((e) => {
          if (cancelled) return;
          if (retriesLeft > 0) {
            setTimeout(() => attempt(retriesLeft - 1), 500);
            return;
          }
          setState({ loading: false, error: e.message, notFound: false, data: null });
        });

    attempt(1);
    return () => { cancelled = true; };
  }, [slug]);
  return state;
}
